import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../../order/Order.sass';

class OrderSummary06Remark extends React.Component {
  static propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({})),
    value: PropTypes.arrayOf(PropTypes.string),
    modelDataText: PropTypes.shape().isRequired,
    currentLocale: PropTypes.string.isRequired,
  };

  static defaultProps = {
    value: [],
    images: [],
  };

  render() {
    return (
      <div className={`${s.summaryRemark}`}>
        <p className={s2.orderSmallTitle}>
          {this.props.currentLocale === 'ko-KR'
            ? this.props.modelDataText.order_summary_remark_title_show
            : this.props.modelDataText.order_summary_remark_title}
        </p>
        <hr className={s2.hrBottom} />
        <p>
          {this.props.value.map((v, i) => (
            <span key={i.toString()}>
              {v}
              <br />
            </span>
          ))}
        </p>
        <div className={s2.summaryGoodsImages}>
          {this.props.images
            .filter(i => Object.keys(i).length > 0)
            .map((i, index) => (
              <div key={index.toString()} className={s2.summaryGoodsImage}>
                <img
                  style={{
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundImage: `url(${i.base64})`,
                  }}
                  width="100"
                  height="100"
                  alt=""
                />
              </div>
            ))}
        </div>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  address: state.order.address,
  remark: state.order.remark,
  passengerCount: state.order.passenger_count,
  tunnel: state.order.tunnel,
  images: state.order.images,
  vehicle: state.order.vehicle,
  pickupTime: state.order.pickup_time,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
  orderDetailInfo: state.order.orderDetailInfo,
});
export default connect(mapState)(
  withStyles(bootstrap, s, s2)(OrderSummary06Remark),
);



// WEBPACK FOOTER //
// ./src/routes/OrderSummary/OrderSummary06Remark/OrderSummary06Remark.js